import slug from 'slug'

export function useAnchorTitle(title) {
  try {
    return slug(title, { lower: true, trim: true, strict: true })
  }
  catch (err) {
    console.error(err)
    return ''
  }
}
